export type EnnismoreServicePrefix = 'config' | 'booking';

/**
 * The Ennismore API has a bunch of different variations of base URL for services.
 * https://api.dev.env.ennismore.com (OWS)
 * https://api.dev.env.ennismore.com/v2 (Kong + OHIP routes)
 * https://gateway.dev.env.ennismore.com/<service prefix> (AWS API Gateway)
 *
 * Hopefully in the future this can be simplified.
 *
 * @param baseUrl
 * @param config
 */
export function buildBaseUrl(
  baseUrl: string,
  config: { servicePrefix: EnnismoreServicePrefix }
) {
  // If we're targeting the new API gateway, we need to pass the service name to the end of the base URL.
  // Yes - this logic is gross.
  if (baseUrl.startsWith('https://gateway')) {
    const url = new URL(config.servicePrefix, baseUrl);
    return url.toString();
  }

  return baseUrl;
}
